/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Cc_Position_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to position events: {error}" |
*
* @param {Shortcut_Keys_Cc_Position_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_cc_position_failed_toast = /** @type {((inputs: Shortcut_Keys_Cc_Position_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Cc_Position_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du positionnement des evenements : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Positionieren der Ereignisse: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile posizionare gli eventi: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось разместить события: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron posicionar los eventos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件定位失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベントの配置に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`घटनाओं को स्थान देने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao posicionar eventos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to position events: ${i?.error}`)
});